import React, {memo} from "react";
import {Helmet} from "react-helmet";

export const PageTitle = memo(({title}: {title: string}) => (
    <Helmet>
        <title>{`Unibuddy - ${title}`}</title>
    </Helmet>
));
